import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'

const encryptor = new JSEncrypt()

/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 *  */
export function aesEncrypt(word: string, keyWord: string = '') {
  const key = CryptoJS.enc.Base64.parse(keyWord)
  const srcStr = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcStr, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

/**
 * @word 要解密的内容
 * @keyWord String 服务器随机返回的关键字
 */
export function aesDecrypt(word: string = '', keyWord: string = '') {
  const key = CryptoJS.enc.Base64.parse(keyWord)
  return CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8)
}

/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 * @description 这个加密方法是给滑块使用的
 *  */
export function aesUtf8Encrypt(word: string, keyWord = 'XwKsGlMcdPMEhR1B') {
  const key = CryptoJS.enc.Utf8.parse(keyWord)
  const srcStr = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcStr, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

/**
 * 获取 API 请求头保护信息
 */
export function getApiHeaderProtect(api: string | undefined) {
  api = api ?? ''
  const publicKey = import.meta.env.VITE_ENCRYPT_PUBLIC_KEY
  if (!publicKey) {
    return ''
  }
  const timestamp = Date.now()
  const nonce = Math.random().toString(36).slice(2, 6) // 生成随机数
  const plainText = `E${nonce}0|${timestamp}|${getLast30Chars(api)}`
  encryptor.setPublicKey(publicKey)
  const encrypted = encryptor.encrypt(plainText)
  return encrypted || ''
}

/**
 *
 * @description 取字符串后30位长度
 * @param str
 * @returns str
 */
function getLast30Chars(str: string) {
  if (typeof str !== 'string') return ''
  return str.slice(-30)
}
